﻿$.fn.dxCtrlCalendarCellTemplate = function custom_dxCtrlCalendarCellTemplate(option) {
    if (option == "instance") {
        return this.instance;
    }
    else {
        this.addClass("dx-ctrlcalendarcelltemplate dx-ctrl");
        this.createInstance(new cdxCtrlCalendarCellTemplate(this, option));
    }
    return this;
}

window.cdxCtrlCalendarCellTemplate = function (container, option) {
    var Me = this;

    this.option = function (name, value) {
        if (typeof value == 'undefined') {
            return option[name];
        }
        else {
            option[name] = value;
            dx.option(name, value);
        }
    }

    if (!option.lstDateOccup) option.lstDateOccup = []
    option.lstDateOccup.forEach(function (dats) {
        dats.date_debut = new Date(dats.date_debut.getFullYear(), dats.date_debut.getMonth(), dats.date_debut.getDate());
        dats.date_fin = new Date(dats.date_fin.getFullYear(), dats.date_fin.getMonth(), dats.date_fin.getDate());
    })

    var $DivDate = null
    this.isLibre = true
    function mConstruit() {
        container.empty();
        container.addClass("state_hover")
        container.css({
            "width": "100%",
            "height": "100%",
            "position": "relative",
            "display": "flex",
            "align-items": "center",
            "justify-content": "center",
            "text-align": "center",
            "opacity": "1",
            "border": "1px solid " + theme.color.replace("rgb(", "rgba(").replace(")", ",0.1)")
        })
        $DivDate = $("<div style='z-index:3;position:absolute;border-radius:50%;padding:2px;font-size:150%;font-weight:bold;' class='numday'></div>").appendTo(container)

        switch (option.itemDataCell.view) {
            case "month":
                $DivDate.text(option.itemDataCell.date.getDate())
                mTraiteToday()
                mRempliOccup()
                //affiche les vacances
                if (option.showVacances) mShowVacances()
                break;
            case "year":
                container.css("opacity", "1")
                $DivDate.text(option.itemDataCell.date.monthName())
                break;
            case "decade":
                container.css("opacity", "1")
                $DivDate.text(option.itemDataCell.date.getFullYear())
                break;
            case "century":
                container.css("opacity", "1")
                $DivDate.text(option.itemDataCell.text)
                break;
        }
    }

    this.isLibre = function (dat) {
        var datRef = new Date(dat.getFullYear(), dat.getMonth(), dat.getDate());
        return option.lstDateOccup.filter(function (dats) {
            //return (datRef >= dats.date_debut && datRef < dats.date_fin)
            return (datRef > dats.date_debut && datRef < dats.date_fin)
        }).length == 0
    }
    this.isColoredRedOccup = function (dat) {
        var datRef = new Date(dat.getFullYear(), dat.getMonth(), dat.getDate());
        return option.lstDateOccup.filter(function (dats) {
            return (datRef >= dats.date_debut && datRef < dats.date_fin)
        }).length > 0
    }

    function mRempliOccup() {
        container.attr("title", (Me.isLibre(option.itemDataCell.date) ? "Ouvert" : "Fermé"))
        window.setTimeout(function () {
            //affichage jour bloqué
            if (Me.isColoredRedOccup(option.itemDataCell.date)) {
                $("<div style='position:absolute;bottom:0px;left:0px;width:0;height:0;border-style:solid;border-width:0 0 " + container.innerHeight() + "px " + container.innerWidth() + "px;border-color: transparent transparent #ff8080 transparent;opacity:0.8;'/>").appendTo(container)
            }
            var dateBefore = (new Date(option.itemDataCell.date)).addDays(-1)
            if (Me.isColoredRedOccup(dateBefore)) {
                $("<div style='position:absolute;bottom:0px;left:0px;width:0;height:0;border-style:solid;border-width:" + container.innerHeight() + "px " + container.innerWidth() + "px 0 0;border-color: #ff8080 transparent transparent transparent;opacity:0.8;'/>").appendTo(container)
            }

            //affichage selected dates
            if (option.selectedDates) {
                if (option.selectedDates.date_debut && option.selectedDates.date_debut.toDDMMMAA() == option.itemDataCell.date.toDDMMMAA()) {
                    $("<div style='position:absolute;bottom:0px;left:0px;width:0;height:0;border-style:solid;border-width:0 0 " + container.innerHeight() + "px " + container.innerWidth() + "px;border-color: transparent transparent #5aff58 transparent;opacity:0.5;'/>").appendTo(container)
                } else if (option.selectedDates.date_fin && option.selectedDates.date_fin.toDDMMMAA() == option.itemDataCell.date.toDDMMMAA()) {
                    $("<div style='position:absolute;bottom:0px;left:0px;width:0;height:0;border-style:solid;border-width:" + container.innerHeight() + "px " + container.innerWidth() + "px 0 0;border-color: #5aff58 transparent transparent transparent;opacity:0.5;'/>").appendTo(container)
                } else if (option.selectedDates.date_debut != null && option.selectedDates.date_fin != null && option.selectedDates.date_fin && option.itemDataCell.date >= option.selectedDates.date_debut && option.itemDataCell.date <= option.selectedDates.date_fin) {
                    $("<div style='position:absolute;bottom:0px;left:0px;height:100%;width:100%;background-color:#5aff58;opacity:0.5;'/>").appendTo(container)
                }
            }
        }, 0)
    }

    function mTraiteToday() {
        if (option.itemDataCell.date.getFullYear() == (new Date()).getFullYear() && option.itemDataCell.date.getMonth() == (new Date()).getMonth() && option.itemDataCell.date.getDate() == (new Date()).getDate()) {
            $DivDate.css({
                "border": "3px solid " + theme.backgroundcolorAccent
            })
        }
    }

    function mShowVacances() {
        var libVac = parametre.vacances.mGetLibelleZone(option.itemDataCell.date)
        //if (libVac.length > 0) {
        //    $("<div style='position:absolute;top:1px;left:2px;font-size:60%;opacity:0.5;z-index:2'>" + libVac + "</div>").appendTo(container)
        //    container.css("background-color", theme.backgroundcolorAccent.replace("rgb(", "rgba(").replace(")", ",0.2)"))
        //}
        //var jourFerie = parametre.joursFeries.getIsDateFerie(option.itemDataCell.date)
        //if (jourFerie) {
        //    container.css("background-color", theme.backgroundcolorAccent.replace("rgb(", "rgba(").replace(")", ",0.4)"))
        //}
        if (libVac.length > 0) {
            $("<div style='position:absolute;top:1px;left:2px;font-size:60%;opacity:0.5;z-index:2;background-color:yellow;border-radius:5px;padding:2px;'>" + libVac + "</div>").appendTo(container)
            //container.css("background-color", "rgba(255, 255, 0,0.3)")
        }
        var jourFerie = parametre.joursFeries.getIsDateFerie(option.itemDataCell.date)
        if (jourFerie) {
            container.css("background-color", "rgba(255, 255, 0, 0.5)")
        }
    }

    //function mShowTauxOccup() {
    //    var heightPercent = option.bddCtrl.getObjet("reservation").objetMetier.mGetPercentOccupe(option.itemDataCell.date)
    //    var $Div = $("<div style='position:absolute;bottom:0px;right:0px;height:" + heightPercent + "%;width:10px;background-color:green;opacity:1;'/>").appendTo(container).attr("title", "Taux d'occupation de <b>" + heightPercent + "%</b>")
    //    $.minimalTips($Div)

    //    //if (heightPercent >= 100) {
    //    //    var fontSize = container.innerHeight()
    //    //    $("<i class='fas fa-times' style='font-size:" + fontSize + "px;position:absolute;top:0;left:0;color:red;opacity:0.5;z-index:5;margin-left:calc(50% - " + (fontSize / 3) + "px);'></i>").appendTo(container)
    //    //    $("<div style='position:absolute;bottom:0px;left:0px;width:0;height:0;border-style:solid;border-width:0 0 " + container.innerHeight() + "px " + container.innerWidth() + "px;border-color: transparent transparent #ff8080 transparent;opacity:0.8;'/>").appendTo(container)
    //    //}
    //    //var heightPercent = option.bddCtrl.getObjet("reservation").objetMetier.mGetPercentOccupe((new Date(option.itemDataCell.date)).addDays(-1))
    //    //if (heightPercent >= 100) {
    //    //    $("<div style='position:absolute;bottom:0px;left:0px;width:0;height:0;border-style:solid;border-width:" + container.innerHeight() + "px " + container.innerWidth() + "px 0 0;border-color: #ff8080 transparent transparent transparent;opacity:0.8;'/>").appendTo(container)
    //    //}
    //}

    //function mShowSimulationTarif() {
    //    var prix = ""
    //    var tarif = (option.objSimulTarif.objTarif ? option.objSimulTarif.objTarif.data : null)
    //    if (option.objHebergementForOccupe) {
    //        prix = option.objHebergementForOccupe.objetMetier.mGetPrixPersonneNuit(option.itemDataCell.date, option.objSimulTarif.nbPers, option.objSimulTarif.nbNuit, tarif)
    //    } else {
    //        prix = option.objSimulTarif.objTarif.objetMetier.mGetPrixPersonneNuit(option.itemDataCell.date, option.objSimulTarif.nbPers, option.objSimulTarif.nbNuit)
    //    }
    //    var txt = parseFloat(prix) + "€"
    //    $("<div style='position:absolute;bottom:0;right:0;font-size:100%;'>" + txt + "</div>").appendTo(container)
    //}

    mConstruit();

}